import { useSelector } from "react-redux";
import { useConfigurator } from "./useConfigurator";
import { RootState } from "Store/mainStore";
import React from "react";

export const useActivePackages = () => {
  const {
    getPackageFieldList,
    preparePackageElementContent,
  } = useConfigurator();

  let deviceBlock = {};
  const configstepperSelector = useSelector((state: RootState) => state.config_stepper);
  const allRefs = React.useRef([]);
  

  /** getBlockContent */
  const getBlockContentData = (packageDataDetails) => {
    const { dB, jD } = preparePackageElementContent(packageDataDetails);
    deviceBlock = { ...dB };
    return JSON.parse(JSON.stringify(jD));
  };

  const getDeviceBlockData = () => {
    return deviceBlock;
  }

  const getActivePackagesData = () => {
    const packageData = getPackageFieldList(configstepperSelector.data.active_step);
    const activePackages = getBlockContentData(packageData);
    return activePackages;
  }

  return {
    getBlockContentData,
    getActivePackagesData,
    getDeviceBlockData,
  }
}